export enum MessageType {
  TEXT = "text",
  CHART = "chart",
  CARD = "card",
  BUTTON = "button",
  LIST = "list",
  TABLE = "table",
  IMAGE = "image",
  HANDOFF = "handoff",
  SUGGESTION = "suggestion",
  ERROR = "error"
}

export interface Message {
  id: string;
  conversationId: string;
  agentId: string;
  role: "user" | "assistant" | "system";
  content: string;
  type: MessageType;
  metadata?: any;
  timestamp: string;
  actions?: MessageAction[];
}

export interface MessageAction {
  id: string;
  label: string;
  action: string;
  data?: any;
}

export interface Conversation {
  id: string;
  userId: string;
  agentId: string;
  context: Record<string, any>;
  status: "active" | "completed" | "handed_off";
  startedAt: string;
  endedAt?: string;
}

export interface AgentConfig {
  id: string;
  name: string;
  description: string;
  capabilities: string[];
  welcomeMessage: string;
  systemPrompt: string;
  toolSelectionPrompt?: string;
  responseGenerationPrompt?: string;
  quickActions?: string[];
  tools?: AgentTool[];
  handoffRules?: HandoffRule[];
}

export interface AgentTool {
  name: string;
  description: string;
  parameters: Record<string, any>;
  handler: (params: any) => Promise<any>;
}

export interface HandoffRule {
  condition: (context: any) => boolean;
  targetAgent: string;
  message: string;
}

export interface ChartData {
  type: "line" | "bar" | "pie" | "donut" | "area";
  title: string;
  data: any;
  options?: any;
}

export interface CardData {
  title: string;
  description?: string;
  image?: string;
  stats?: Array<{
    label: string;
    value: string | number;
    trend?: "up" | "down" | "neutral";
  }>;
  actions?: MessageAction[];
}

export interface TableData {
  headers: string[];
  rows: Array<Array<string | number>>;
  caption?: string;
}